import axios from "axios";
import {useMutation, useQuery} from "@tanstack/vue-query";
import {computed, ref} from "vue";
import {errorToast} from "@/composables/useToasts";
import {axiosDownloadFile} from "@/composables/downloadFile";

const citationReportFinished = ref(false);

const staleTime = 1000 * 60 * 60 * 24 * 30;

const selectedLocation = ref(0);
const disableExportButton = ref(true);

const getCitations = (isGbpLocation) => useQuery({
  queryKey: ['citations', {selectedLocation}],
  queryFn: async () => {
    const {data} = await axios.get(
      isGbpLocation ? `/ajax/v2/citations/${selectedLocation.value}` : '/ajax/v2/local/citations',
    );

    citationReportFinished.value = data.data.report_finished;
    disableExportButton.value = data.data.total_listings_count === 0;

    return data.data;
  },
  staleTime,
  refetchInterval: (query) => {
    if (query.state.status === 'error') {
      return false;
    }

    return !citationReportFinished.value ? 10000 : false;
  },
  enabled: () => !!selectedLocation.value
});

const getCitationSync = () => useQuery({
  queryKey: ['citation-sync', {selectedLocation}],
  queryFn: async () => {
    const {data} = await axios.get(`/ajax/v2/citations/${selectedLocation.value}/sync`);
    disableExportButton.value = data.total_listings_count === 0;
    return data;
  },
  staleTime,
  enabled: () => !!selectedLocation.value
});

const downloadExportMutation = () => useMutation({
  mutationFn: async ({hasKit, isGbpLocation}) => {
    let uri = `/ajax/v2/citations/${selectedLocation.value}/export`;

    if (hasKit) {
       uri = `/ajax/v2/citations/${selectedLocation.value}/export/sync`;
    }

    if (!isGbpLocation) {
      uri = '/ajax/v2/local/citations/export';
    }

    await axiosDownloadFile(
      uri,
    );
  },
  onError: () => errorToast('Something went wrong'),
});

export {
  getCitations,
  getCitationSync,
  downloadExportMutation,
  disableExportButton,
  selectedLocation,
};
